type BooksyPayStore = {
  getters: {
    'identity/isOwner': boolean
  }
}

export const resolveBooksyPayEntryRedirect = (
  store: BooksyPayStore
): Record<string, unknown> | null => {
  if (!store.getters['identity/isOwner']) {
    return { name: 'calendar' }
  }

  return null
}
